import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { FormMode, Languages, RestudyMeasFirstReviewerDecision, ServiceStatus } from 'src/app/shared/models/enums.model';
import {ReleaseRestudyRequestDTO,ReleaseRestudyAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-first-reviewer',
  templateUrl: './first-reviewer.component.html'
})
export class FirstReviewerComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  refundRequestObj: ReleaseRestudyRequestDTO = new ReleaseRestudyRequestDTO();
  restudyAdminObj: ReleaseRestudyAdminDTO = new ReleaseRestudyAdminDTO();
  decision = RestudyMeasFirstReviewerDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  user: User = new User();
  restudyMeasFirstReviewerForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  @Input() public isRealseForm: boolean = true;
  // @Input() public ShowReleaseForm: boolean = true;
  isLoaded: boolean = false;
  ListOfAdmins: [] = [];
  adminsDropdownSettings = {};
  selectedEmails: [] = [];



  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private longhaulserv: LongHaulService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'Email',
      textField: 'Username',
      selectAllText: 'Select All',
      unSelectAllText:  'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }
  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {

    this.restudyMeasFirstReviewerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
      this.restudyMeasFirstReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Admins: ['',[Validators.required]]
      });
    }
    else if (decision == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_MoreInformation) {
      this.restudyMeasFirstReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
  }
  get form() {
    return this.restudyMeasFirstReviewerForm.controls;
  }

  changeDecision(value) {
    this.buildForm(value);
    this.restudyMeasFirstReviewerForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
    if(this.decisionValue == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_Approve){
      this.getNextStepUsers();
    }
  }

  getRequest() {
    this.longhaulserv.GetRestudyRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.refundRequestObj = this.responseObj.Data;
          this.requestStatus = this.refundRequestObj.BaseRequest.StatusId;
          this.isLoaded = true;

          if (history.state.data && history.state.data.isCompleted) {
            this.decisionValue = this.refundRequestObj.MeasReviewerDecision;
            if (this.refundRequestObj.MeasReviewerDecision == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.restudyMeasFirstReviewerForm.patchValue({
                Decision: this.decisionValue,
                MoreInformation: this.refundRequestObj.MeasReviewerNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.restudyMeasFirstReviewerForm.patchValue({
                Decision: this.decisionValue,
              });
            }
            this.formMode = FormMode.Readonly;
            this.restudyMeasFirstReviewerForm.disable();
          }
          else if(this.requestStatus == ServiceStatus.Restudy_RestudyUnderReview){
            this.formMode = FormMode.Add;
            this.restudyMeasFirstReviewerForm.enable();
          }
          else{
            this.formMode = FormMode.Readonly;
            this.restudyMeasFirstReviewerForm.disable();
            this.decisionValue = this.refundRequestObj.MeasReviewerDecision;
            if (this.refundRequestObj.MeasReviewerDecision == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.restudyMeasFirstReviewerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.refundRequestObj.MeasReviewerNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.restudyMeasFirstReviewerForm.patchValue({
                Decision: this.decisionValue,
              });
            }
          }
        }
      }
    )
  }

  getNextStepUsers() {
    this.longhaulserv.GetNextStepUsers('SCAServices_RestudyManager').subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          this.ListOfAdmins = resObj.Data;
        }
      }
    )
  }

  nextUsersListChanged() {
    if (this.form.Admins && this.form.Admins.value != null) {
      this.selectedEmails = this.form.Admins.value.map(function (e) {
        return e.Email;
      });
    }
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.restudyMeasFirstReviewerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.restudyAdminObj.AdminEmail = this.user.UserName;
    this.restudyAdminObj.Id = this.baseRequestId;
    this.restudyAdminObj.MeasReviewerDecision = this.decisionValue;
    if (this.decisionValue == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
      this.restudyAdminObj.WFNextUsers = this.selectedEmails;
    } else {
      this.restudyAdminObj.MeasReviewerNotes = this.restudyMeasFirstReviewerForm.controls.MoreInformation.value;
    }
    this.longhaulserv.SubmitRestudyMeasFirstReviewerDecision(this.restudyAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.restudyMeasFirstReviewerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}

